import React, { useState, useEffect } from "react";
import { Grid } from "@material-ui/core";

import MUIDataTable from "mui-datatables";

// components
import PageTitle from "../../../components/PageTitle/PageTitle";


// data
import { OnlineLoanList} from "./onlineLoanList-api"
//auth
import auth from "../../../auth/auth-helper";

const columns = [
  {
    name: "account_no",
    label: "Accunt No",
    options: {
      filter: true,
      sort: true,
    },
  },
  {
    name: "amount",
    label: "Amount",
  },
  {
    name: "approved_by",
    label: "Approved by",
  },
  {
    name: "approved_date",
    label: "Approved Date",
  },
  {
    name: "branch_name",
    label: "Branch Name",
  },
  {
    name: "installment",
    label: "Installement",
  },
  {
    name: "installment_type",
    label: "Installement Type",
  },
  {
    name: "loan_status",
    label: "Status",
  },
  {
    name: "loan_type",
    label: "Loan Type",
  },
  {
    name: "requested_by",
    label: "Requested By",
  },
  {
    name: "time_period",
    label: "Time Peroid",
  },
];


export default function OnlineLoans() {
  const [onlineloans, setOnlineloans] = useState([]);

  useEffect(() => {
    const abortController = new AbortController();
    const signal = abortController.signal;
    const credentials = auth.isAuthenticated();

    OnlineLoanList(signal,credentials).then((res) => {
      if (res.status === 200) {
        console.log('token here .....................'+ credentials);
        // console.log(res.status);
        console.log(res);
        //console.log(res.statusCode);
        setOnlineloans(res.response[0]);
      } else {
        
      }
     
    });

    return function cleanup() {
      abortController.abort();
    };
  }, []);
  return (
    <>
      <PageTitle title="Online Loans" />
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <MUIDataTable
            title="Online-Loan List"
            data={onlineloans}
            columns={columns}
            options={{
              filterType: "checkbox",
            }}
          />
        </Grid>
        {/* <Grid item xs={12}>
          <Widget title="Material-UI Table" upperTitle noBodyPadding bodyClass={classes.tableOverflow}>
            <Table data={mock.table} />
          </Widget>
        </Grid> */}
      </Grid>
    </>
  );
}